// TODO: rename APPLICATION according to backend changes in the future

export const PAGE_CODES = {
  ACCOUNTS_USERS: 'accounts.users',
  ACCOUNTING_SETTINGS: 'accountingSetting',
  ADJUSTMENTS: 'adjustmentCriteria',
  MARGIN_CRITERIA: 'marginCriteria',
  MARGIN_GUARDRAIL: 'marginGuardrail',
  MARGIN_CHANGE_REQUEST: 'marginChangeRequest',
  MARGIN_PLAN: 'marginPlan',
  CAPTURE_POLICY: 'capturePolicy',
  LOAN_CONCESSION_REQUEST: 'loanConcessionRequest',
  DASHBOARDS: 'dashboards',
  COMPANY_APP_KEYS: 'company.appKeys',
  INTERNAL_COMPANY_APP_KEYS: 'internal.company.appKeys',
  AUTOMATED_ACTION_CRITERIA: 'automatedActionCriteria',
  LLPA_CAP: 'llpaCapCriteria',
  MI_COVERAGE_CRITERIA: 'miCoveragePercentageCriteria',
  APPLICATION: 'application',
  AUDIO_RECORDINGS: 'audioRecording',
  COMPANY: 'company',
  CHANNEL: 'channel',
  CLOSING_PORTAL: 'closingPortal',
  CLOSING_PORTAL_LOGIN: 'closingPortalLogin',
  INTERNAL_OB_CONFIGURATION: 'internal.optimalBlueConfiguration',
  INTERNAL_DOCUMENT_CATEGORY: 'internal.documentCategory',
  INTERNAL_DOCUMENT_TYPE: 'internal.documentType',
  INTERNAL_DOCUMENT_FIELD_TYPE: 'internal.documentFieldType',
  DOCUMENTS: 'document',
  DOWNLOAD_AND_PRINT_DOCUMENT: 'document.downloadAndPrint',
  COPY_DOCUMENTS_TO_ANOTHER_LOAN: 'document.copyDocumentsToAnotherLoan',
  LOAN_DOCUMENT: 'loanDocument',
  LOAN_UNDERWRITING: 'loanUnderwriting',
  DOCUMENT_BUNDLE_TYPE: 'documentBundleType',
  ELIGIBILITY_BUILDER: 'eligibilityCriteria',
  MI_RULES: 'miRules',
  RATE_LOCK_TERMS: 'rateLockTerms',
  ESCROW_REQUIREMENTS: 'escrowRequirements',
  LEAD_SOURCES: 'leadSource',
  PRICING_WORKBENCH: 'pricingWorkbench',
  PROGRAM: 'program',
  BUY_DOWNS: 'buyDownAdministration',
  CUSTOM_ADJUSTMENTS: 'customPricingAdjustments',
  INTERNAL_INDEX_TYPE: 'internal.indexType',
  USERS: 'user',
  USERS_LICENSED_STATE: 'user.licensedState',
  USERS_ASSIGN_MANAGER: 'user.assignManager',
  INTERNAL_COMPANY_USERS_LICENSED_STATE: 'internal.company.users.licensedState',
  INTERNAL_COMPANY_CREATE_FROM_TEMPLATE: 'internal.company.createFromTemplate',
  USERS_ROLES: 'user.securityGroup',
  INTERNAL_COMPANY_USERS_ROLES: 'internal.company.users.securityGroup',
  USERS_PROPERTIES: 'user.properties',
  USERS_TELEPHONY: 'user.telephony',
  INTERNAL_COMPANY_USERS_TELEPHONY: 'internal.company.users.telephony',
  CHANNEL_PROGRAM: 'channelProgram',
  ADVANCE: 'advance',
  PURCHASED_LOANS: 'purchasedLoans',
  COMPANY_DOMAINS: 'companyDomain',
  COMPANY_EMAIL_DOMAINS: 'emailSendingDomain',
  PURCHASE_ADVICE: 'purchaseAdvice',
  INVESTORS: 'investor',
  DEALERS: 'dealer',
  SERVICING_COMPANY: 'servicingCompany',
  COMPANY_LICENSE_STATE: 'companyLicenseState',
  WAREHOUSE_BANKS: 'warehouseBank',
  CSV_MAPPINGS: 'csvMapping',
  DOCUMENT_EXTRACTION: 'documentExtraction',
  SYSTEM_PROPERTIES: 'systemProperty',
  WEBHOOKS: 'webhooks',
  MSR: 'msr',
  USERS_LEAD_ASSIGNMENT: 'user.leadAssignment',
  INTERNAL_COMPANY_LEAD_ASSIGNMENT: 'internal.company.users.leadAssignment',
  ROLES: 'securityGroup',
  ROLES_ANALYTICS_DASHBOARD: 'securityGroup.analyticsDashboard',
  ROLES_REPORT_BUILDERS: 'securityGroup.reportBuilders',
  LOAN_ROLE: 'loanRole',
  LOAN_ROLE_RELATIONSHIPS: 'loanRoleRelationships',
  BROKERS: 'broker',
  BROKER_LENDERS: 'brokerLenders',
  REALTORS: 'realtors',
  REPORT_BUILDERS_VIEW: 'reportBuildersView',
  APPLY_FORM_CUSTOM_QUESTIONS: 'applyFormCustomQuestions',
  FORMS: 'form',
  TASK_FORM: 'taskForm',
  FORM_BUNDLE: 'formBundle',
  FORM_BUNDLE_TESTING_TOOL: 'formBundle.testingTool',
  INTERNAL_SYSTEM_SETTINGS: 'internal.systemSetting',
  INTERNAL_AUTH: 'internal.auth',
  INTERNAL_COMPANIES: 'internal.company',
  INTERNAL_COMPANIES_USERS: 'internal.company.users',
  INTERNAL_COMPANIES_DOMAINS: 'internal.company.domains',
  INTERNAL_COMPANIES_EMAIL_DOMAINS: 'internal.company.emailSendingDomains',
  INTERNAL_COMPANIES_SYSTEM_PROPERTIES: 'internal.company.systemProperties',
  INTERNAL_COMPANIES_CLAIMS_CONFIGURATION: 'internal.company.claimsConfiguration',
  INTERNAL_COMPANIES_ROLE_CONFIGURATION: 'internal.company.roleConfiguration',
  INTERNAL_COMPANY_WHITELIST: 'internal.company.whitelist',
  COMPANY_IP_WHITELIST: 'company.ipWhitelist',
  TASK_TYPES: 'taskType',
  TASK_CATEGORIES: 'taskCategory',
  HEADER_VIEW_LOAN: 'headerView.loan',
  HEADER_VIEW_CONTACT: 'headerView.contact',
  HEADER_VIEW_LEAD: 'headerView.lead',
  HEADER_VIEW_SUB_COMPANY: 'headerView.subCompany',
  LOAN_ACTIONS: 'loanActions',
  EMAIL_TEMPLATE: 'emailTemplate',
  UNDERWRITING_REPORTS: 'underwriting.report',
  UNDERWRITING_SETTINGS: 'underwriting.settings',
  UNDERWRITING_DOCUMENT_EXPIRATION_SETTINGS: 'underwriting.documentExpirationSettings',
  UNDERWRITING_RULES: 'underwriting.rule',
  UNDERWRITING_CONDITIONS: 'conditions',
  UNDERWRITING_CONDITION_CATEGORIES: 'conditions.categories',
  LOAN_CONDITIONS: 'loanConditions',
  LOAN_CONDITIONS_SIGN_OFF: 'loanConditions.signOff',
  LOAN_CONDITIONS_UNSIGN_OFF: 'loanConditions.unsignOff',
  LOAN_CONDITIONS_REJECT: 'loanConditions.reject',
  UNDERWRITING_SLA_GROUPS: 'slaGroups',
  LOAN_APPLICATION: 'loanEditor',
  LOAN_EDITOR_AI_ACTIVITY: 'loanEditor.aiActivity',
  LOAN_EDITOR_CIC_HISTORY: 'loanEditor.cicHistory',
  LOAN_EDITOR_VENDOR_REQUESTS: 'loanEditor.vendorRequests',
  LOAN_EDITOR_LOAN_ROLE_ASSIGNEMENT: 'loanEditor.loanRoleAssignments',
  LOAN_EDITOR_LOAN_TAG_ASSIGNEMENT: 'loanEditor.loanTagAssignments',
  LOAN_EDITOR_DOCUMENT_EXTRACTION_FIELDS: 'loanEditor.documentExtractionFields',
  LOAN_EDITOR_DOCUMENT_ASSOCIATIONS: 'loanEditor.documentAssociations',
  LOAN_EDITOR_FUNDING_INFO: 'loanEditor.fundingInformation',
  LOAN_EDITOR_CLOSING: 'loanEditor.closing',
  LOAN_EDITOR_POST_CLOSING: 'loanEditor.postClosing',
  LOAN_EDITOR_PROFIT_AND_LOSS: 'loanEditor.loanProfitAndLoss',
  LOAN_EDITOR_TRANSACTION_DETAILS: 'loanEditor.transactionDetails',
  LOAN_EDITOR_CONTACTS: 'loanEditor.loanContacts',
  LOAN_EDITOR_APPRAISAL_SELECTION: 'loanEditor.appraisalSelection',
  LOAN_LOCK_INFO: 'loanLockInfo',
  CUSTOM_PRICE_ADJUSTMENT: 'loanLockInfo.customPriceAdjustment',
  EDIT_RATE_SHEET_ASSOCIATION: 'loanLockInfo.editRateSheetAssociation',
  IGNORE_LOCK_EXPIRATION: 'loanLockInfo.ignoreLockExpiration',
  REASSIGN_LOAN: 'reassignLoan',
  APPRAISAL_PRODUCT_CRITERIA: 'appraisalProductCriteria',
  APPRAISAL_SURCHARGE_CRITERIA: 'appraisalSurchargeCriteria',
  CHECKLISTS: 'checklistsManagement',
  LOAN_CHECKLISTS: 'loanChecklists',
  COMPANY_AUDIO_RECORDINGS: 'companyAudioRecording',
  TASKS: 'task',
  FEE_TYPES: 'feeType',
  SELLER_ADJUSTMENT_TYPES: 'sellerAdjustmentType',
  CIC_FEE_REASONS: 'cicFeeReason',
  FEE_PROVIDER_CATEGORY: 'internal.feeProviderCategory',
  FEE_PROVIDER: 'feeProvider',
  WORK_SCHEDULER: 'calendarEvent',
  WORK_SCHEDULER_BY_STATE: 'calendarEvent.stateSummary',
  LOAN_OFFICERS_MANAGEMENT: 'loManagement',
  FORM_BUNDLE_SIGNATURE_REQUEST: 'formBundleSignatureRequest',
  FORM_DELIVERY: 'formDelivery',
  MARK_TO_MARKET: 'markToMarketSetting',
  PIPELINES: 'loanPipelines',
  PIPELINE_LOAN_VIEW: 'pipelineLoanView',
  TAGS: 'tag',
  TURN_TIME_DEFINITIONS: 'turnTimeDefinitions',
  LOAN_FEES: 'loanFees',
  LOCK_EXTENSIONS: 'lockExtension',
  FLOAT_DOWN: 'floatDown',
  LLPA_TYPE: 'llpaType',
  CUBE_HISTORY: 'cubeHistory',
  EMAIL_SIGNATURE_TEMPLATE: 'emailSignatureTemplate',
  EMAIL_SNIPPETS_TEMPLATE: 'emailSnippetsTemplate',
  APPRAISAL_PRODUCTS: 'appraisalProduct',
  // TODO(DEV-2234): tighten claim once BE adds a dedicated APPRAISAL_PRODUCT_PRICING claim
  APPRAISAL_PRODUCT_PRICING: 'appraisalProduct',
  // TODO(DEV-2234): tighten claim once BE adds a dedicated APPRAISAL_SURCHARGES claim
  APPRAISAL_SURCHARGES: 'appraisalProduct',
  // FH-1572: HomeVision Job Types gates on the same AppraisalProductPolicy claim as the
  // Appraisal Products page (the new CRUD lives on the AppraisalProduct controller).
  HOMEVISION_JOB_TYPES: 'appraisalProduct',
  DENIAL_REASONS: 'denialReasons',
  MIN_DEACTIVATION_TYPES: 'minDeactivationTypes',
  UNSALABLE_RESPONSIBLE_PARTIES: 'unsalableResponsibleParties',
  UNSALABLE_REASONS: 'unsalableReasons',
  EXCEPTION_SUB_CATEGORIES: 'exceptionTracking',
  EXCEPTION_TRACKING_REPORT: 'exceptionTracking',
  DOCUMENT_EXTRACTION_FIELDS_MAPPING: 'documentExtractionFieldsMapping',
  LOAN_INFORMATION_PRICING: 'loanInformationPricing',
  COMPANY_AUS_SETTINGS: 'company.ausSettings',
  INTERNAL_COMPANY_AUS_SETTINGS: 'internal.company.ausSettings',
  LOAN_DENIAL: 'loanDenial',
  COMPANY_BUSINESS_SCHEDULE: 'company.businessSchedule',
  INTERNAL_COMPANY_BUSINESS_SCHEDULE: 'internal.company.businessSchedule',
  MANAGE_LOAN_FLOW_MILESTONES: 'manageLoanFlowMilestones',
  VESTING_TYPE: 'vestingType',
  INVESTOR_FEATURE_CODES: 'investorFeatureCodes',
  PROGRAM_IDENTIFIERS: 'programIdentifiers',
  PRICING_CONFIGURATION: 'pricingConfiguration',
  CUSTOM_FIELD_DEFINITIONS: 'customFieldDefinitions',
  LOAN_EDITOR_CUSTOM_FORMS: 'loanEditorCustomForms',
  FILE_REQUEST: 'fileRequest',
  LOGIN: 'login',
  SSO_LOGIN: 'ssoLogin',
  AUTO_LOGIN: 'autoLogin',
  COMPANY_CENTER: 'companyCenter',
  COMPANY_MANAGER: 'companyManager',
  SUB_COMPANIES: 'subCompany',
  SUB_COMPANIES_LICENSED_STATES: 'subCompany.licenseState',
  SUB_COMPANIES_COMPENSATION_PLANS: 'subCompany.compensationPlan',
  SUB_COMPANIES_CERTIFICATION: 'subCompany.certification',
  SUB_COMPANIES_DOCUMENTS: 'subCompany.documents',
  SUB_COMPANIES_AI_ACTIVITY: 'subCompany.aiActivity',
  SUB_COMPANIES_CHECKLISTS: 'subCompanyChecklists',
  AUTO_LOCK_RULES_MANAGEMENT: 'autoLockRulesManagement',
  ANALYTICS_ADMIN: 'securityGroup.analyticsAdmin',
  CONTACT_TYPES: 'contactTypes',
  COMMAND_CENTER_MANAGE_ANNOUNCEMENTS: 'commandCenter.manageAnnouncements',
  AI_PERSONAS: 'aiPersonas',
  AI_PROCESSES: 'aiProcesses',
  KNOWLEDGE: 'knowledge',
  AI_LOG: 'aiLog',
  AI_CHAT_CONFIGURATIONS: 'aiChat',
  CHAT_ESCALATION_LADDER: 'chatEscalationLadder',
  AI_MODELS: 'aiModels',
  AI_AGENTS: 'aiAgents',
  AI_SKILLS: 'aiSkills',
  GUIDELINES: 'guidelines',
  LOAN_EDITOR_SERVICING: 'loanEditor.servicing',
  CONSTRUCTION: 'loanEditor.construction',
  TRADE_MANAGEMENT: 'tradeManagement',
  POS_CONFIGURATIONS: 'posConfiguration',
  POS_LOCALIZATION_STRINGS: 'localizationString',
  TPO_SIGNUP_CONFIGURATIONS: 'tpoSignupConfiguration',
  ADVISOR_PORTAL_CONFIGURATIONS: 'advisorPortalConfiguration',
  WAREHOUSE_BANK_LINE_MANAGEMENT: 'warehouseBankLineManagement',
  CRM_TAGS: 'crm.tags',
  CRM_CONTACTS: 'crm.contacts',
  CRM_NOTES: 'crm.notes',
  CRM_CAMPAIGNS: 'crm.campaigns',
  INTERNAL_HTTP_REQUEST_LOG: 'internal.httpRequestLog',
  TEXML_APPLICATIONS: 'texmlApplications',
  NOTIFICATION_DISPATCHER: 'notificationDispatcher',
  INTEGRATION_STUDIO: 'integrations',
  INTEGRATION_STUDIO_VIEW: 'integrations',
  COMPANY_FORM_FIELD_DATA: 'company.formFieldData',
  COMPANY_AUTH_METHOD: 'company.authMethod',
  COMPANY_MOBILE_APP_RELEASE: 'company.mobileAppRelease',
  COMPANY_MOBILE_APP_RELEASE_MANAGE: 'company.mobileAppRelease.manage',
};
